// extracted by mini-css-extract-plugin
export var addButton = "pricing-cards-module--add-button--N8bdQ";
export var bottom = "pricing-cards-module--bottom--Cfko3";
export var bottomCard = "pricing-cards-module--bottom-card--+YyyC";
export var bottomOpen = "pricing-cards-module--bottom-open--yJnZ9";
export var bottomText = "pricing-cards-module--bottom-text--lww4G";
export var bottomTitle = "pricing-cards-module--bottom-title--WEQ5j";
export var checkIcon = "pricing-cards-module--check-icon--eKKab";
export var closeIcon = "pricing-cards-module--close-icon--iyvz7";
export var container = "pricing-cards-module--container--QT+w1";
export var description = "pricing-cards-module--description--cv9oG";
export var detailName = "pricing-cards-module--detail-name--0i5Ab";
export var detailOption = "pricing-cards-module--detail-option--9n2lJ";
export var detailOptionButton = "pricing-cards-module--detail-option-button--WGBzl";
export var detailOptionCell = "pricing-cards-module--detail-option-cell--q+hU+";
export var detailOptionGrid = "pricing-cards-module--detail-option-grid--4-b-u";
export var detailOptionInfo = "pricing-cards-module--detail-option-info--1+xnH";
export var detailOptions = "pricing-cards-module--detail-options--YF2KC";
export var details = "pricing-cards-module--details--AuCqH";
export var forWhoButton = "pricing-cards-module--for-who-button--NF3Ug";
export var header = "pricing-cards-module--header--6AKfY";
export var infoIcon = "pricing-cards-module--info-icon--zY535";
export var initialOverflow = "pricing-cards-module--initial-overflow--HXhjh";
export var maxPrice = "pricing-cards-module--max-price--fB2NR";
export var name = "pricing-cards-module--name--S33-j";
export var nameMobile = "pricing-cards-module--name-mobile--h4LZp";
export var oneTime = "pricing-cards-module--one-time--Asj+S";
export var popular = "pricing-cards-module--popular--ag+of";
export var price = "pricing-cards-module--price--UYcGE";
export var priceBox = "pricing-cards-module--price-box--W0-tn";
export var priceInfo = "pricing-cards-module--price-info--V1cFj";
export var prices = "pricing-cards-module--prices--LcU2k";
export var ribbon = "pricing-cards-module--ribbon--FivI7";
export var table = "pricing-cards-module--table--L43zl";
export var titleBox = "pricing-cards-module--title-box--uGbP2";
export var top = "pricing-cards-module--top--5w5yB";
export var topCard = "pricing-cards-module--top-card--dzEx6";